import rosettaSdk from "@product/rosetta-sdk";
import { useEffect } from "react";
import type { FunctionComponent } from "react";

export const RosettaCampaignPopup: FunctionComponent = () => {
  useEffect(() => {
    rosettaSdk.getService("campaignPopUp")?.showCampaignPopUp({
      tracking: {
        customized_parameters: {
          trigger_point: "homepage subscription popup",
        },
      },
    });
  }, []);
  return null;
};
